import { Api } from "../../api/api";

export class MultiselectApi extends Api {
    static refresh(relativeElem: HTMLElement, uuid: string) {
        return MultiselectApi.callApiFn(relativeElem, "s25-ng-multiselect", "initComp", null, undefined, (comp, i) => {
            return comp && comp.modelBean && comp.modelBean.uuid === uuid;
        });
    }

    static forceScrollAction(relativeElem: HTMLElement, uuid: string) {
        return MultiselectApi.callApiFn(
            relativeElem,
            "s25-ng-multiselect",
            "forceScrollAction",
            null,
            undefined,
            (comp, i) => {
                return comp && comp.modelBean && comp.modelBean.uuid === uuid;
            },
        );
    }
}

export class MultiselectResultsApi extends Api {
    static refresh(relativeElem: HTMLElement, uuid: string) {
        return MultiselectResultsApi.callApiFn(
            relativeElem,
            "s25-ng-multiselect-results",
            "refresh",
            null,
            undefined,
            (comp, i) => {
                return comp?.uuid() === uuid;
            },
        );
    }
}

export class MultiselectPopupApi extends Api {
    static close(relativeElem: HTMLElement, uuid: string) {
        return MultiselectPopupApi.callApiFn(
            relativeElem,
            "s25-ng-multiselect-popup",
            "forceClose",
            null,
            undefined,
            (comp, i) => {
                return comp && comp.modelBean && comp.modelBean.uuid === uuid;
            },
        );
    }
}
